import Loadable from "@loadable/component";

const addToWishlistButton = Loadable(
  () =>
    import(
      /* webpackChunkName: "product_add_to_wishlist_component" */ "./addToWishlistButton"
    )
);

export default addToWishlistButton;
